module.exports = __webpack_public_path__ + "img/1490011996.2e7d24ef.jpg";